import { Modal } from '@/components/ui/Modal';

interface PrivacyModalProps {
  open: boolean;
  onClose: () => void;
}

export function PrivacyModal({ open, onClose }: PrivacyModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="Privacy">
      <section className="privacy-section">
        <p>
          Slime Pang stores a small amount of anonymous gameplay data so the leaderboard works. When
          you choose to watch an ad, third-party advertising networks are loaded as described in
          &ldquo;Advertising&rdquo; below.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="privacy-collected">
        <h3 id="privacy-collected">What we store</h3>
        <ul>
          <li>
            A random device ID generated on this device. It is not linked to your name, email, or
            any account.
          </li>
          <li>The display name you choose when submitting a score.</li>
          <li>
            A country code derived from your browser&rsquo;s language setting (for example,{' '}
            <code>en-US</code> &rarr; <code>US</code>). Your IP address and location are not used by
            us.
          </li>
          <li>Your score, play time, longest combo, submission time, and game version.</li>
        </ul>
      </section>

      <section className="privacy-section" aria-labelledby="privacy-use">
        <h3 id="privacy-use">How it is used</h3>
        <p>
          Leaderboard data is used only to rank scores. We do not sell it, share it with
          advertisers, or use it to profile you across other sites.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="privacy-local">
        <h3 id="privacy-local">Saved on this device</h3>
        <p>
          Settings, gold, bonus tokens, and your personal best are kept in your browser&rsquo;s
          local storage. Clearing your browser data resets them.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="privacy-ads">
        <h3 id="privacy-ads">Advertising</h3>
        <p>
          Slime Pang shows ads served by GameMonetize and Google&rsquo;s advertising network. When
          an ad plays, these networks may use cookies, local storage, and similar technologies to
          deliver relevant ads, limit how often you see the same ad, and measure ad performance.
        </p>
        <p>These are separate services with their own privacy policies:</p>
        <ul>
          <li>
            GameMonetize:{' '}
            <a
              href="https://gamemonetize.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              gamemonetize.com/privacy-policy
            </a>
          </li>
          <li>
            Google Ads:{' '}
            <a
              href="https://policies.google.com/technologies/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              policies.google.com/technologies/ads
            </a>
          </li>
        </ul>
        <p>We do not receive or store information collected by the ad networks.</p>
      </section>

      <section className="privacy-section" aria-labelledby="privacy-rights">
        <h3 id="privacy-rights">Your rights</h3>
        <p>
          You can clear ad cookies by clearing your browser&rsquo;s site data for slimepang.com.
          EU/EEA/UK users have rights under GDPR (access, deletion, correction). California
          residents have rights under CCPA. To make a request, contact:{' '}
          <a href="mailto:reimaginegamestudio@gmail.com">reimaginegamestudio@gmail.com</a>.
        </p>
      </section>
    </Modal>
  );
}
